// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  overflow-x: hidden;
}
.audit-trail-no-scroll {
  height: 100vh;
  overflow: hidden;
}

.search-results-section,
.summary-section {
  width: 100%;
}

.ag-theme-alpine,
.ag-theme-manage-providers {
  width: 100% !important;
  font-family: 'Jost', sans-serif !important;
}

.ag-root-wrapper {
  border: none !important;
}

.ag-theme-alpine .ag-header,
.ag-theme-manage-providers .ag-header {
  background-color: #DBE2E9 !important;
  border-bottom: 1px solid #C9CED5 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #344049 !important;
}

.ag-theme-alpine .ag-header-cell,
.ag-theme-manage-providers .ag-header-cell {
  border-right: 1px solid #C9CED5 !important;
}

.ag-theme-alpine .ag-header-cell-label,
.ag-theme-manage-providers .ag-header-cell-label {
  justify-content: center !important;
  color: #344049 !important;
}

.ag-theme-alpine .ag-header-cell-left .ag-header-cell-label,
.ag-theme-manage-providers .ag-header-cell-left .ag-header-cell-label {
  justify-content: flex-start !important;
  padding-left: 20px !important;
}

.ag-theme-alpine .ag-row,
.ag-theme-manage-providers .ag-row {
  border-bottom: 1px solid #F0F2F5 !important;
  background-color: #ffffff !important;
  font-size: 13px !important;
}

.ag-theme-alpine .ag-cell,
.ag-theme-manage-providers .ag-cell {
  display: flex !important;
  align-items: center !important;
  border-right: 1px solid #F0F2F5 !important;
}

.ag-theme-manage-providers .ag-cell-wrapper {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

.ag-theme-manage-providers .ag-group-value {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

.ag-theme-manage-providers .ag-group-expanded,
.ag-theme-manage-providers .ag-group-contracted {
  color: #333 !important;
  margin-right: 4px !important;
}

.ag-theme-manage-providers .ag-group-expanded:not(.ag-hidden),
.ag-theme-manage-providers .ag-group-contracted:not(.ag-hidden) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* .ag-theme-alpine .ag-row-selected,
.ag-theme-alpine .ag-row-focus,
.ag-theme-manage-providers .ag-row-selected,
.ag-theme-manage-providers .ag-row-focus {
  background-color: #f8fafc !important;
} */


.ag-details-row {
  background-color: #fff !important;
  padding: 0 !important;
  border-top: 1px solid #eee;
}

.detail-inner-container {
  padding: 24px;
}

.ag-details-grid {
  padding: 0 !important;
}

.ag-body-viewport::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.ag-body-viewport::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 3px;
}

.ag-body-viewport::-webkit-scrollbar-track {
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/audit-trail/AuditTrailsFix.css"],"names":[],"mappings":"AAAA;;EAEE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;EACpC,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;;EAEE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;;EAEE,2CAA2C;EAC3C,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;;;;GAKG;;;AAGH;EACE,iCAAiC;EACjC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["body,\nhtml {\n  overflow-x: hidden;\n}\n.audit-trail-no-scroll {\n  height: 100vh;\n  overflow: hidden;\n}\n\n.search-results-section,\n.summary-section {\n  width: 100%;\n}\n\n.ag-theme-alpine,\n.ag-theme-manage-providers {\n  width: 100% !important;\n  font-family: 'Jost', sans-serif !important;\n}\n\n.ag-root-wrapper {\n  border: none !important;\n}\n\n.ag-theme-alpine .ag-header,\n.ag-theme-manage-providers .ag-header {\n  background-color: #DBE2E9 !important;\n  border-bottom: 1px solid #C9CED5 !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: #344049 !important;\n}\n\n.ag-theme-alpine .ag-header-cell,\n.ag-theme-manage-providers .ag-header-cell {\n  border-right: 1px solid #C9CED5 !important;\n}\n\n.ag-theme-alpine .ag-header-cell-label,\n.ag-theme-manage-providers .ag-header-cell-label {\n  justify-content: center !important;\n  color: #344049 !important;\n}\n\n.ag-theme-alpine .ag-header-cell-left .ag-header-cell-label,\n.ag-theme-manage-providers .ag-header-cell-left .ag-header-cell-label {\n  justify-content: flex-start !important;\n  padding-left: 20px !important;\n}\n\n.ag-theme-alpine .ag-row,\n.ag-theme-manage-providers .ag-row {\n  border-bottom: 1px solid #F0F2F5 !important;\n  background-color: #ffffff !important;\n  font-size: 13px !important;\n}\n\n.ag-theme-alpine .ag-cell,\n.ag-theme-manage-providers .ag-cell {\n  display: flex !important;\n  align-items: center !important;\n  border-right: 1px solid #F0F2F5 !important;\n}\n\n.ag-theme-manage-providers .ag-cell-wrapper {\n  display: flex !important;\n  align-items: center !important;\n  height: 100% !important;\n}\n\n.ag-theme-manage-providers .ag-group-value {\n  display: flex !important;\n  align-items: center !important;\n  height: 100% !important;\n}\n\n.ag-theme-manage-providers .ag-group-expanded,\n.ag-theme-manage-providers .ag-group-contracted {\n  color: #333 !important;\n  margin-right: 4px !important;\n}\n\n.ag-theme-manage-providers .ag-group-expanded:not(.ag-hidden),\n.ag-theme-manage-providers .ag-group-contracted:not(.ag-hidden) {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* .ag-theme-alpine .ag-row-selected,\n.ag-theme-alpine .ag-row-focus,\n.ag-theme-manage-providers .ag-row-selected,\n.ag-theme-manage-providers .ag-row-focus {\n  background-color: #f8fafc !important;\n} */\n\n\n.ag-details-row {\n  background-color: #fff !important;\n  padding: 0 !important;\n  border-top: 1px solid #eee;\n}\n\n.detail-inner-container {\n  padding: 24px;\n}\n\n.ag-details-grid {\n  padding: 0 !important;\n}\n\n.ag-body-viewport::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.ag-body-viewport::-webkit-scrollbar-thumb {\n  background: #D1D5DB;\n  border-radius: 3px;\n}\n\n.ag-body-viewport::-webkit-scrollbar-track {\n  background: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
